module.exports = __webpack_public_path__ + "img/wz-3-10.bc60f5a1.png";